
import ActionsForm from '@/shared/mixins/actionsForm'
import SurveyRepository from '@/shared/http/repositories/business/Survey'
import { loading, toast } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../static/img/survey/cabecalho_qma_pdf.svg'
import smfoto from '../../../../static/img/survey/sem-foto.png'
import surveycriticalactivityRepository from '@/shared/http/repositories/business/surveycriticalactivity'
import VistoriaEpiRepository from '@/shared/http/repositories/business/surveyEquipment'

// import jwtDecode from "jwt-decode"

export default {
  name: 'tableInqueryQmaPivs',
  mixins: [ActionsForm],
  components: {VueHtml2pdf},
  data () {
    return {
      validaAcesso: false,
      semImg: smfoto,
      atividadeCritiaca: [],
      dadosCabecalho: [],
      equipamentos: [],
      dataImgVistoria: [],
      vistoriaId: null,
      status: {
        Mensagem: '',
        Cor: '',
        CorTexto: ''
      }
    }
  },
  watch: {
  },

  mounted () {
    this.token = this.$route.params.token
    this.validacaoAcessoUsuarioMob()
  },

  methods: {
    async validacaoAcessoUsuarioMob () {
      loading.push()
      let validar = { Token: this.token }

      try {
        const res = await SurveyRepository.ValidarTokenPDF(validar)
        loading.pop()
        this.vistoriaId = res.data
        this.cabecalho(res.data)
      } catch (erro) {
        loading.pop()
        return toast.error(erro.response.data)
      }
    },
    async cabecalho (id) {
      loading.push()

      try {
        const res = await SurveyRepository.GetAllCabecalhoMobilePdf(id)
        loading.pop()
        this.dadosCabecalho = res.data[0]
        this.formatStatusVistoria(this.dadosCabecalho.statusvistoria)
        this.GetAtividadeCritica(id)
        this.onLoadEquipamento(id)
        this.onLoadImg(id)
      } catch (erro) {
        loading.pop()
        return toast.error(erro.response.data)
      }
    },
    GetAtividadeCritica (id) {
      loading.push()
      surveycriticalactivityRepository.getvistoriaItensPdfMob({VistoriaId: id})
        .then(Response => {
          this.atividadeCritiaca = Response.data.data
        })
        .catch(Error => this.onException(Error))
    },
    onLoadImg (id) {
      loading.push()
      SurveyRepository.imgVistoriaMobPdf({VistoriaId: id})
        .then(Response => {
          this.dataImgVistoria = Response.data[0]
          loading.pop()
          this.$nextTick(() => {
            this.generatePDF()
          })
        })
        .catch(Error => this.onException(Error))
    },
    onLoadEquipamento (id) {
      loading.push()
      VistoriaEpiRepository.vistoriapdfmob({VistoriaId: id})
        .then(Response => {
          this.equipamentos = Response.data.data
          console.log('ENTROU AQUI')
          this.validaAcesso = true
          // Aguarde o Vue renderizar os dados antes de chamar generatePDF
          loading.pop()
        })
        .catch(Error => this.onException(Error))
    },
    formatStatusVistoria (value) {
      if (value === 0) {
        this.status.Mensagem = 'NÃO ENVIADO'
        this.status.Cor = 'rgb(192, 192, 192)'
        this.status.CorTexto = 'rgb(106, 106, 106)'
      }
      if (value === 1) {
        this.status.Mensagem = 'AG. APROVAÇÃO'
        this.status.Cor = 'rgb(212, 238, 253)'
        this.status.CorTexto = 'rgb(0, 55, 137)'
      }
      if (value === 2) {
        this.status.Mensagem = 'AG. CORREÇÃO'
        this.status.Cor = '#ffeadc'
        this.status.CorTexto = 'rgb(255 96 0 / 92%)'
      }
      if (value === 3) {
        this.status.Mensagem = 'APROVADO'
        this.status.Cor = '#cbe9cf'
        this.status.CorTexto = 'rgb(19, 59, 26)'
      }
    },

    generatePDF () {
      if (!this.$refs.html2Pdf) {
        console.log('Erro: Componente PDF ainda não carregado.')
        return
      }
      console.log('Gerando PDF...')
      this.$refs.html2Pdf.generatePdf()
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [2.4, 0, 0.5, 0]

      html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          pdf.addFileToVFS('Poppins-Bold.ttf')
          pdf.addFont('Poppins-Bold.ttf', 'Poppins', 'bold', 'WinAnsiEncoding')
          pdf.setFont('Poppins', 'bold')
          const totalPages = pdf.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)

            // Header Section
            pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
            pdf.setTextColor('#333333')
            pdf.setFontSize(15)
            pdf.setFont('helvetica', 'bold')
            pdf.text('RELATÓRIO DE SAÚDE E SEGURANÇA DO TRABALHO EM OBRA', 0.8, 1.5)

            // Title Section with Poppins font
            pdf.setFillColor('#F4F4F4')
            const rectWidth = pdf.internal.pageSize.getWidth() - 0.6
            pdf.roundedRect(0.35, 1.75, rectWidth, 0.5, 0.1, 0.1, 'F')
            pdf.setTextColor('#666666')
            pdf.setFontSize(10)
            pdf.text('Cliente: ' + this.dadosCabecalho.responsavelNome, 0.5, 2.05)
            pdf.text('N° do Contrato: ' + this.dadosCabecalho.numeroContrato, 6, 2.05)
            // pdf.text('Data da Vistoria: ' + this.qmaData.dataVistoriaFormatadaNotHour, 5, 2.05)

            // Footer Section
            pdf.setFillColor(28, 98, 40)
            pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
            pdf.setTextColor('#fff')
            pdf.setFontSize(10)
            pdf.text('SST - Relatório Saúde e Segurança do Trabalho em Obra', 0.5, pdf.internal.pageSize.getHeight() - 0.1)
            pdf.text(`Pág ${i} de ${totalPages}`, 7, pdf.internal.pageSize.getHeight() - 0.1)
          }
          // Criando o Blob para abrir a nova guia
          const pdfBlob = pdf.output('blob')
          const pdfUrl = URL.createObjectURL(pdfBlob)
          // Abre o PDF em uma nova guia
          window.location.href = pdfUrl // Fazendo o download do PDF
          pdf.save('documento.pdf')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/public/surveyPDF/validPdfAccess.js